import { NgModule } from '@angular/core';
import { PreloadAllModules, Router, RouterModule, Routes } from '@angular/router';
import {
  AuthGuard,
  redirectLoggedInTo,
  customClaims
} from '@angular/fire/auth-guard';
import { pipe } from 'rxjs';
import { map } from 'rxjs/operators';

const redirectLoggedInToHome = () => redirectLoggedInTo(['']);
const driverOnly = () => pipe(
  customClaims,
  map((claims: any) => {
    if ((claims && claims.role === 'driver') || (claims && claims.role === 'assistant')) {
      return true;
    }
    return ['login'];
  })
);

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'daily-report',
    loadComponent: () => import('./reports/daily-report/daily-report.page').then(m => m.DailyReportPage)
  },
  {
    path: 'home',
    loadComponent: () => import('./home/home.page').then(m => m.HomePage),
    canActivate: [AuthGuard],
    data: { authGuardPipe: driverOnly }
  },
  {
    path: 'late-report',
    loadComponent: () => import('./reports/late-report/late-report.page').then( m => m.LateReportPage)
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.page').then(m => m.LoginPage),
    canActivate: [AuthGuard],
    data: { authGuardPipe: redirectLoggedInToHome }
  },
  {
    path: 'route-report',
    loadComponent: () => import('./reports/route-report/route-report.page').then(m => m.RouteReportPage)
  },
  {
    path: 'start-trip',
    loadComponent: () => import('./trips/start-trip/start-trip.page').then(m => m.StartTripPage)
  },
  {
    path: 'student-detail',
    loadComponent: () => import('./students/student-detail/student-detail.page').then(m => m.StudentDetailPage)
  },
  {
    path: 'student-list',
    loadComponent: () => import('./students/student-list/student-list.page').then(m => m.StudentListPage)
  },
  {
    path: 'student-report',
    loadComponent: () => import('./reports/student-report/student-report.page').then(m => m.StudentReportPage)
  },
  {
    path: 'trips/:id',
    children: [
      {
        path: 'active',
        loadComponent: () => import('./trips/active-trip/active-trip.page').then( m => m.ActiveTripPage)
      },
      {
        path: 'end',
        loadComponent: () => import('./trips/end-trip/end-trip.page').then( m => m.EndTripPage)
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor(private router: Router) {}
}
